/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 7.34.1
 * source: subscriptions/members.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as pb_1 from "google-protobuf";
import * as grpc_1 from "@grpc/grpc-js";
import * as grpc_web_1 from "grpc-web";
export namespace subscriptions.v1 {
    export enum InvitationStatus {
        INVITATION_STATUS_UNSPECIFIED = 0,
        INVITATION_STATUS_PENDING = 1,
        INVITATION_STATUS_PENDING_REGISTRATION = 2,
        INVITATION_STATUS_ACCEPTED = 3,
        INVITATION_STATUS_REJECTED = 4,
        INVITATION_STATUS_EXPIRED = 5
    }
    export class SubscriptionInvitation extends pb_1.Message {
        #one_of_decls: number[][] = [[3]];
        constructor(data?: any[] | ({
            id?: string;
            subscriptionId?: string;
            invitedBy?: string;
            email?: string;
            status?: InvitationStatus;
        } & (({
            userId?: string;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("subscriptionId" in data && data.subscriptionId != undefined) {
                    this.subscriptionId = data.subscriptionId;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("invitedBy" in data && data.invitedBy != undefined) {
                    this.invitedBy = data.invitedBy;
                }
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get subscriptionId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set subscriptionId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setOneofField(this, 3, this.#one_of_decls[0], value);
        }
        get hasUserId() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get invitedBy() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set invitedBy(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 6, InvitationStatus.INVITATION_STATUS_UNSPECIFIED) as InvitationStatus;
        }
        set status(value: InvitationStatus) {
            pb_1.Message.setField(this, 6, value);
        }
        get _user_id() {
            const cases: {
                [index: number]: "none" | "userId";
            } = {
                0: "none",
                3: "userId"
            };
            return cases[pb_1.Message.computeOneofCase(this, [3])];
        }
        static fromObject(data: {
            id?: string;
            subscriptionId?: string;
            userId?: string;
            invitedBy?: string;
            email?: string;
            status?: InvitationStatus;
        }): SubscriptionInvitation {
            const message = new SubscriptionInvitation({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.subscriptionId != null) {
                message.subscriptionId = data.subscriptionId;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.invitedBy != null) {
                message.invitedBy = data.invitedBy;
            }
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                subscriptionId?: string;
                userId?: string;
                invitedBy?: string;
                email?: string;
                status?: InvitationStatus;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.subscriptionId != null) {
                data.subscriptionId = this.subscriptionId;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.invitedBy != null) {
                data.invitedBy = this.invitedBy;
            }
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.subscriptionId.length)
                writer.writeString(2, this.subscriptionId);
            if (this.hasUserId)
                writer.writeString(3, this.userId);
            if (this.invitedBy.length)
                writer.writeString(4, this.invitedBy);
            if (this.email.length)
                writer.writeString(5, this.email);
            if (this.status != InvitationStatus.INVITATION_STATUS_UNSPECIFIED)
                writer.writeEnum(6, this.status);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubscriptionInvitation {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SubscriptionInvitation();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.subscriptionId = reader.readString();
                        break;
                    case 3:
                        message.userId = reader.readString();
                        break;
                    case 4:
                        message.invitedBy = reader.readString();
                        break;
                    case 5:
                        message.email = reader.readString();
                        break;
                    case 6:
                        message.status = reader.readEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SubscriptionInvitation {
            return SubscriptionInvitation.deserialize(bytes);
        }
    }
    export class SubscriptionMember extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            name?: string;
            email?: string;
            isActive?: boolean;
            isOwner?: boolean;
            userExternalId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("isActive" in data && data.isActive != undefined) {
                    this.isActive = data.isActive;
                }
                if ("isOwner" in data && data.isOwner != undefined) {
                    this.isOwner = data.isOwner;
                }
                if ("userExternalId" in data && data.userExternalId != undefined) {
                    this.userExternalId = data.userExternalId;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get isActive() {
            return pb_1.Message.getFieldWithDefault(this, 4, false) as boolean;
        }
        set isActive(value: boolean) {
            pb_1.Message.setField(this, 4, value);
        }
        get isOwner() {
            return pb_1.Message.getFieldWithDefault(this, 5, false) as boolean;
        }
        set isOwner(value: boolean) {
            pb_1.Message.setField(this, 5, value);
        }
        get userExternalId() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set userExternalId(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        static fromObject(data: {
            id?: string;
            name?: string;
            email?: string;
            isActive?: boolean;
            isOwner?: boolean;
            userExternalId?: string;
        }): SubscriptionMember {
            const message = new SubscriptionMember({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.isActive != null) {
                message.isActive = data.isActive;
            }
            if (data.isOwner != null) {
                message.isOwner = data.isOwner;
            }
            if (data.userExternalId != null) {
                message.userExternalId = data.userExternalId;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                name?: string;
                email?: string;
                isActive?: boolean;
                isOwner?: boolean;
                userExternalId?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.isActive != null) {
                data.isActive = this.isActive;
            }
            if (this.isOwner != null) {
                data.isOwner = this.isOwner;
            }
            if (this.userExternalId != null) {
                data.userExternalId = this.userExternalId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.name.length)
                writer.writeString(2, this.name);
            if (this.email.length)
                writer.writeString(3, this.email);
            if (this.isActive != false)
                writer.writeBool(4, this.isActive);
            if (this.isOwner != false)
                writer.writeBool(5, this.isOwner);
            if (this.userExternalId.length)
                writer.writeString(6, this.userExternalId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubscriptionMember {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SubscriptionMember();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.name = reader.readString();
                        break;
                    case 3:
                        message.email = reader.readString();
                        break;
                    case 4:
                        message.isActive = reader.readBool();
                        break;
                    case 5:
                        message.isOwner = reader.readBool();
                        break;
                    case 6:
                        message.userExternalId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SubscriptionMember {
            return SubscriptionMember.deserialize(bytes);
        }
    }
    export class InviteSubscriptionMemberRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            subscriptionId?: string;
            email?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscriptionId" in data && data.subscriptionId != undefined) {
                    this.subscriptionId = data.subscriptionId;
                }
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
            }
        }
        get subscriptionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set subscriptionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            subscriptionId?: string;
            email?: string;
        }): InviteSubscriptionMemberRequest {
            const message = new InviteSubscriptionMemberRequest({});
            if (data.subscriptionId != null) {
                message.subscriptionId = data.subscriptionId;
            }
            if (data.email != null) {
                message.email = data.email;
            }
            return message;
        }
        toObject() {
            const data: {
                subscriptionId?: string;
                email?: string;
            } = {};
            if (this.subscriptionId != null) {
                data.subscriptionId = this.subscriptionId;
            }
            if (this.email != null) {
                data.email = this.email;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.subscriptionId.length)
                writer.writeString(1, this.subscriptionId);
            if (this.email.length)
                writer.writeString(2, this.email);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): InviteSubscriptionMemberRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new InviteSubscriptionMemberRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.subscriptionId = reader.readString();
                        break;
                    case 2:
                        message.email = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): InviteSubscriptionMemberRequest {
            return InviteSubscriptionMemberRequest.deserialize(bytes);
        }
    }
    export class InviteSubscriptionMemberResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): InviteSubscriptionMemberResponse {
            const message = new InviteSubscriptionMemberResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): InviteSubscriptionMemberResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new InviteSubscriptionMemberResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): InviteSubscriptionMemberResponse {
            return InviteSubscriptionMemberResponse.deserialize(bytes);
        }
    }
    export class RemoveSubscriptionMemberRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            subscriptionId?: string;
            memberId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscriptionId" in data && data.subscriptionId != undefined) {
                    this.subscriptionId = data.subscriptionId;
                }
                if ("memberId" in data && data.memberId != undefined) {
                    this.memberId = data.memberId;
                }
            }
        }
        get subscriptionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set subscriptionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get memberId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set memberId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            subscriptionId?: string;
            memberId?: string;
        }): RemoveSubscriptionMemberRequest {
            const message = new RemoveSubscriptionMemberRequest({});
            if (data.subscriptionId != null) {
                message.subscriptionId = data.subscriptionId;
            }
            if (data.memberId != null) {
                message.memberId = data.memberId;
            }
            return message;
        }
        toObject() {
            const data: {
                subscriptionId?: string;
                memberId?: string;
            } = {};
            if (this.subscriptionId != null) {
                data.subscriptionId = this.subscriptionId;
            }
            if (this.memberId != null) {
                data.memberId = this.memberId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.subscriptionId.length)
                writer.writeString(1, this.subscriptionId);
            if (this.memberId.length)
                writer.writeString(2, this.memberId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RemoveSubscriptionMemberRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RemoveSubscriptionMemberRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.subscriptionId = reader.readString();
                        break;
                    case 2:
                        message.memberId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): RemoveSubscriptionMemberRequest {
            return RemoveSubscriptionMemberRequest.deserialize(bytes);
        }
    }
    export class RemoveSubscriptionMemberResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): RemoveSubscriptionMemberResponse {
            const message = new RemoveSubscriptionMemberResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RemoveSubscriptionMemberResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RemoveSubscriptionMemberResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): RemoveSubscriptionMemberResponse {
            return RemoveSubscriptionMemberResponse.deserialize(bytes);
        }
    }
    export class GetSubscriptionMemberRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): GetSubscriptionMemberRequest {
            const message = new GetSubscriptionMemberRequest({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSubscriptionMemberRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetSubscriptionMemberRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetSubscriptionMemberRequest {
            return GetSubscriptionMemberRequest.deserialize(bytes);
        }
    }
    export class GetSubscriptionMemberResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            member?: SubscriptionMember;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("member" in data && data.member != undefined) {
                    this.member = data.member;
                }
            }
        }
        get member() {
            return pb_1.Message.getWrapperField(this, SubscriptionMember, 1) as SubscriptionMember;
        }
        set member(value: SubscriptionMember) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasMember() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            member?: ReturnType<typeof SubscriptionMember.prototype.toObject>;
        }): GetSubscriptionMemberResponse {
            const message = new GetSubscriptionMemberResponse({});
            if (data.member != null) {
                message.member = SubscriptionMember.fromObject(data.member);
            }
            return message;
        }
        toObject() {
            const data: {
                member?: ReturnType<typeof SubscriptionMember.prototype.toObject>;
            } = {};
            if (this.member != null) {
                data.member = this.member.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasMember)
                writer.writeMessage(1, this.member, () => this.member.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSubscriptionMemberResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetSubscriptionMemberResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.member, () => message.member = SubscriptionMember.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetSubscriptionMemberResponse {
            return GetSubscriptionMemberResponse.deserialize(bytes);
        }
    }
    export class ListSubscriptionMembersRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            subscriptionId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscriptionId" in data && data.subscriptionId != undefined) {
                    this.subscriptionId = data.subscriptionId;
                }
            }
        }
        get subscriptionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set subscriptionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            subscriptionId?: string;
        }): ListSubscriptionMembersRequest {
            const message = new ListSubscriptionMembersRequest({});
            if (data.subscriptionId != null) {
                message.subscriptionId = data.subscriptionId;
            }
            return message;
        }
        toObject() {
            const data: {
                subscriptionId?: string;
            } = {};
            if (this.subscriptionId != null) {
                data.subscriptionId = this.subscriptionId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.subscriptionId.length)
                writer.writeString(1, this.subscriptionId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListSubscriptionMembersRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListSubscriptionMembersRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.subscriptionId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListSubscriptionMembersRequest {
            return ListSubscriptionMembersRequest.deserialize(bytes);
        }
    }
    export class ListSubscriptionMembersResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            members?: SubscriptionMember[];
            invitations?: SubscriptionInvitation[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1, 2], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("members" in data && data.members != undefined) {
                    this.members = data.members;
                }
                if ("invitations" in data && data.invitations != undefined) {
                    this.invitations = data.invitations;
                }
            }
        }
        get members() {
            return pb_1.Message.getRepeatedWrapperField(this, SubscriptionMember, 1) as SubscriptionMember[];
        }
        set members(value: SubscriptionMember[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        get invitations() {
            return pb_1.Message.getRepeatedWrapperField(this, SubscriptionInvitation, 2) as SubscriptionInvitation[];
        }
        set invitations(value: SubscriptionInvitation[]) {
            pb_1.Message.setRepeatedWrapperField(this, 2, value);
        }
        static fromObject(data: {
            members?: ReturnType<typeof SubscriptionMember.prototype.toObject>[];
            invitations?: ReturnType<typeof SubscriptionInvitation.prototype.toObject>[];
        }): ListSubscriptionMembersResponse {
            const message = new ListSubscriptionMembersResponse({});
            if (data.members != null) {
                message.members = data.members.map(item => SubscriptionMember.fromObject(item));
            }
            if (data.invitations != null) {
                message.invitations = data.invitations.map(item => SubscriptionInvitation.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                members?: ReturnType<typeof SubscriptionMember.prototype.toObject>[];
                invitations?: ReturnType<typeof SubscriptionInvitation.prototype.toObject>[];
            } = {};
            if (this.members != null) {
                data.members = this.members.map((item: SubscriptionMember) => item.toObject());
            }
            if (this.invitations != null) {
                data.invitations = this.invitations.map((item: SubscriptionInvitation) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.members.length)
                writer.writeRepeatedMessage(1, this.members, (item: SubscriptionMember) => item.serialize(writer));
            if (this.invitations.length)
                writer.writeRepeatedMessage(2, this.invitations, (item: SubscriptionInvitation) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListSubscriptionMembersResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListSubscriptionMembersResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.members, () => pb_1.Message.addToRepeatedWrapperField(message, 1, SubscriptionMember.deserialize(reader), SubscriptionMember));
                        break;
                    case 2:
                        reader.readMessage(message.invitations, () => pb_1.Message.addToRepeatedWrapperField(message, 2, SubscriptionInvitation.deserialize(reader), SubscriptionInvitation));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListSubscriptionMembersResponse {
            return ListSubscriptionMembersResponse.deserialize(bytes);
        }
    }
    export abstract class UnimplementedSubscriptionMemberServiceService {
        static definition = {
            InviteSubscriptionMember: {
                path: "/subscriptions.v1.SubscriptionMemberService/InviteSubscriptionMember",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: InviteSubscriptionMemberRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => InviteSubscriptionMemberRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: InviteSubscriptionMemberResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => InviteSubscriptionMemberResponse.deserialize(new Uint8Array(bytes))
            },
            RemoveSubscriptionMember: {
                path: "/subscriptions.v1.SubscriptionMemberService/RemoveSubscriptionMember",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: RemoveSubscriptionMemberRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => RemoveSubscriptionMemberRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: RemoveSubscriptionMemberResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => RemoveSubscriptionMemberResponse.deserialize(new Uint8Array(bytes))
            },
            GetSubscriptionMember: {
                path: "/subscriptions.v1.SubscriptionMemberService/GetSubscriptionMember",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetSubscriptionMemberRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetSubscriptionMemberRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetSubscriptionMemberResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetSubscriptionMemberResponse.deserialize(new Uint8Array(bytes))
            },
            ListSubscriptionMembers: {
                path: "/subscriptions.v1.SubscriptionMemberService/ListSubscriptionMembers",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ListSubscriptionMembersRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ListSubscriptionMembersRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ListSubscriptionMembersResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ListSubscriptionMembersResponse.deserialize(new Uint8Array(bytes))
            }
        };
        [method: string]: grpc_1.UntypedHandleCall;
        abstract InviteSubscriptionMember(call: grpc_1.ServerUnaryCall<InviteSubscriptionMemberRequest, InviteSubscriptionMemberResponse>, callback: grpc_1.sendUnaryData<InviteSubscriptionMemberResponse>): void;
        abstract RemoveSubscriptionMember(call: grpc_1.ServerUnaryCall<RemoveSubscriptionMemberRequest, RemoveSubscriptionMemberResponse>, callback: grpc_1.sendUnaryData<RemoveSubscriptionMemberResponse>): void;
        abstract GetSubscriptionMember(call: grpc_1.ServerUnaryCall<GetSubscriptionMemberRequest, GetSubscriptionMemberResponse>, callback: grpc_1.sendUnaryData<GetSubscriptionMemberResponse>): void;
        abstract ListSubscriptionMembers(call: grpc_1.ServerUnaryCall<ListSubscriptionMembersRequest, ListSubscriptionMembersResponse>, callback: grpc_1.sendUnaryData<ListSubscriptionMembersResponse>): void;
    }
    export class SubscriptionMemberServiceClient {
        private _address: string;
        private _client: grpc_web_1.GrpcWebClientBase;
        constructor(address: string, credentials?: Object, options?: grpc_web_1.GrpcWebClientBaseOptions) {
            if (!options)
                options = {};
            options.format = options.format || "text";
            this._address = address;
            this._client = new grpc_web_1.GrpcWebClientBase(options);
        }
        private static InviteSubscriptionMember = new grpc_web_1.MethodDescriptor<InviteSubscriptionMemberRequest, InviteSubscriptionMemberResponse>("/subscriptions.v1.SubscriptionMemberService/InviteSubscriptionMember", grpc_web_1.MethodType.UNARY, InviteSubscriptionMemberRequest, InviteSubscriptionMemberResponse, (message: InviteSubscriptionMemberRequest) => message.serialize(), InviteSubscriptionMemberResponse.deserialize);
        InviteSubscriptionMember(message: InviteSubscriptionMemberRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<InviteSubscriptionMemberRequest, InviteSubscriptionMemberResponse>(this._address + "/subscriptions.v1.SubscriptionMemberService/InviteSubscriptionMember", message, metadata || {}, SubscriptionMemberServiceClient.InviteSubscriptionMember);
        }
        private static RemoveSubscriptionMember = new grpc_web_1.MethodDescriptor<RemoveSubscriptionMemberRequest, RemoveSubscriptionMemberResponse>("/subscriptions.v1.SubscriptionMemberService/RemoveSubscriptionMember", grpc_web_1.MethodType.UNARY, RemoveSubscriptionMemberRequest, RemoveSubscriptionMemberResponse, (message: RemoveSubscriptionMemberRequest) => message.serialize(), RemoveSubscriptionMemberResponse.deserialize);
        RemoveSubscriptionMember(message: RemoveSubscriptionMemberRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<RemoveSubscriptionMemberRequest, RemoveSubscriptionMemberResponse>(this._address + "/subscriptions.v1.SubscriptionMemberService/RemoveSubscriptionMember", message, metadata || {}, SubscriptionMemberServiceClient.RemoveSubscriptionMember);
        }
        private static GetSubscriptionMember = new grpc_web_1.MethodDescriptor<GetSubscriptionMemberRequest, GetSubscriptionMemberResponse>("/subscriptions.v1.SubscriptionMemberService/GetSubscriptionMember", grpc_web_1.MethodType.UNARY, GetSubscriptionMemberRequest, GetSubscriptionMemberResponse, (message: GetSubscriptionMemberRequest) => message.serialize(), GetSubscriptionMemberResponse.deserialize);
        GetSubscriptionMember(message: GetSubscriptionMemberRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetSubscriptionMemberRequest, GetSubscriptionMemberResponse>(this._address + "/subscriptions.v1.SubscriptionMemberService/GetSubscriptionMember", message, metadata || {}, SubscriptionMemberServiceClient.GetSubscriptionMember);
        }
        private static ListSubscriptionMembers = new grpc_web_1.MethodDescriptor<ListSubscriptionMembersRequest, ListSubscriptionMembersResponse>("/subscriptions.v1.SubscriptionMemberService/ListSubscriptionMembers", grpc_web_1.MethodType.UNARY, ListSubscriptionMembersRequest, ListSubscriptionMembersResponse, (message: ListSubscriptionMembersRequest) => message.serialize(), ListSubscriptionMembersResponse.deserialize);
        ListSubscriptionMembers(message: ListSubscriptionMembersRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ListSubscriptionMembersRequest, ListSubscriptionMembersResponse>(this._address + "/subscriptions.v1.SubscriptionMemberService/ListSubscriptionMembers", message, metadata || {}, SubscriptionMemberServiceClient.ListSubscriptionMembers);
        }
    }
}
